var map = {
	"./animation1.gif": "./src/assets/img/report/audio/animation1.gif",
	"./animation10.gif": "./src/assets/img/report/audio/animation10.gif",
	"./animation11.gif": "./src/assets/img/report/audio/animation11.gif",
	"./animation12.gif": "./src/assets/img/report/audio/animation12.gif",
	"./animation13.gif": "./src/assets/img/report/audio/animation13.gif",
	"./animation14.gif": "./src/assets/img/report/audio/animation14.gif",
	"./animation15.gif": "./src/assets/img/report/audio/animation15.gif",
	"./animation16.gif": "./src/assets/img/report/audio/animation16.gif",
	"./animation17.gif": "./src/assets/img/report/audio/animation17.gif",
	"./animation18.gif": "./src/assets/img/report/audio/animation18.gif",
	"./animation19.gif": "./src/assets/img/report/audio/animation19.gif",
	"./animation2.gif": "./src/assets/img/report/audio/animation2.gif",
	"./animation20.gif": "./src/assets/img/report/audio/animation20.gif",
	"./animation21.gif": "./src/assets/img/report/audio/animation21.gif",
	"./animation22.gif": "./src/assets/img/report/audio/animation22.gif",
	"./animation23.gif": "./src/assets/img/report/audio/animation23.gif",
	"./animation24.gif": "./src/assets/img/report/audio/animation24.gif",
	"./animation25.gif": "./src/assets/img/report/audio/animation25.gif",
	"./animation26.gif": "./src/assets/img/report/audio/animation26.gif",
	"./animation27.gif": "./src/assets/img/report/audio/animation27.gif",
	"./animation28.gif": "./src/assets/img/report/audio/animation28.gif",
	"./animation29.gif": "./src/assets/img/report/audio/animation29.gif",
	"./animation3.gif": "./src/assets/img/report/audio/animation3.gif",
	"./animation30.gif": "./src/assets/img/report/audio/animation30.gif",
	"./animation31.gif": "./src/assets/img/report/audio/animation31.gif",
	"./animation32.gif": "./src/assets/img/report/audio/animation32.gif",
	"./animation33.gif": "./src/assets/img/report/audio/animation33.gif",
	"./animation34.gif": "./src/assets/img/report/audio/animation34.gif",
	"./animation35.gif": "./src/assets/img/report/audio/animation35.gif",
	"./animation4.gif": "./src/assets/img/report/audio/animation4.gif",
	"./animation5.gif": "./src/assets/img/report/audio/animation5.gif",
	"./animation6.gif": "./src/assets/img/report/audio/animation6.gif",
	"./animation7.gif": "./src/assets/img/report/audio/animation7.gif",
	"./animation8.gif": "./src/assets/img/report/audio/animation8.gif",
	"./animation9.gif": "./src/assets/img/report/audio/animation9.gif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/report/audio sync recursive ^\\.\\/animation.*\\.gif$";